export default __webpack_public_path__ + "static/media/play-button-dark.35672c66.svg";